import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Main.css';

function Main() {
  const [categoryList, setCategoryList] = useState([]);


useEffect(() => {
  axios
    .get('/api/v1/category/')
    .then((response) => {
      const allCategories = response.data;

      // Filter out "Re-clubbing" since it has its own section
      const filteredCategories = allCategories.filter(
        (category) => category.name.toLowerCase() !== 're-clubbing'
      );

      setCategoryList(filteredCategories);
    })
    .catch((error) => {
      console.error('Error fetching categories:', error);
    });
}, []);

  return (
    <div className="main">
      {categoryList.map((category) => (
        <div key={category.id} className="main-product-card">

          <div className="main-product-card-image-wrapper">
            <Link to={category.get_absolute_url}>

              {/* Image 1: The Default Image */}
              <img
                src={category.get_image}
                alt={category.name}
                className="img-default"
              />

              {/* Image 2: The Hover Image (Only renders if it exists) */}
              {category.get_hover_image && (
                <img
                  src={category.get_hover_image}
                  alt={`${category.name} hover`}
                  className="img-hover"
                />
              )}

            </Link>
          </div>
          <div className="main-card-title">
            <Link to={category.get_absolute_url}>
              <h1>{category.name}</h1>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Main;
